'use strict';

import {i18n} from '../AppInterface/lib/i18n';
import $ from 'jquery';

export class Glossar {
  constructor(texts) {
    this.texts = texts || {};
  }

  getText(key) {
    const lang = i18n.language;

    if (this.texts[key] && this.texts[key][lang]) {
      return this.texts[key][lang];
    } else {
      return key;
    }
  }

  add(texts) {
    this.texts = $.extend(this.texts, texts);
  }
}

export const glossar = new Glossar();
